<template>
    <Modal :show-footer="false" :show-title="false" @cancel="close">
        <div class="suspended-modal">
            <div class="suspended-modal-title">
                <span class="material-icons alert-icon">notification_important</span>
                Sistem Tarafından Kısıtlandınız
            </div>
            <div class="suspended-modal-description">
                <div class="suspended-modal-description-content">
                    Ödenmeyen faturalarınız bulunduğundan dolayı sistem tarafından kısıtlandınız. Tekrar erişim sağlamak
                    için ödenmemiş faturalarınızı ödemeniz gerekmektedir.
                </div>
            </div>
            <div class="suspended-modal-footer">
                <SupsisButton @click="close" primary>Kapat</SupsisButton>
            </div>
        </div>
    </Modal>
</template>
<script>
import Modal from "../../../../components/common/Modal2.vue";
import SupsisButton from "../../Settings/components/SupsisButton.vue";

export default {
    name: "SuspendedModal",
    components: {
        SupsisButton,
        Modal,
    },
    methods: {
        close() {
            this.$emit("cancel");
        },
        confirm() {
            this.$emit("confirm");
        },
    },
};
</script>
<style lang="scss" scoped>
.suspended-modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;

    .alert-icon {
        font-size: 42px;
        color: rgb(250, 102, 102);
    }

    &-title {
        font-size: medium;
        text-align: center;
        font-weight: bold;
        text-transform: uppercase;
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    &-description {
        display: flex;
        flex-direction: column;
        gap: 10px;
        text-align: center;

        &-content {
            font-size: 14px;
            font-weight: 300;
            display: flex;
            flex-direction: column;
            gap: 10px;
        }
    }
}
</style>
